import { useEffect, useState } from 'react';

const noOp = () => {};

const useOutsideClick = (node, cb, onMount = noOp) => {
	useEffect(() => {
		onMount();

		const onWindowClick = (e) => {
			if (!node.current) return;

			if (!node.current.contains(e.target)) {
				cb(false);
			}
		};

		window.addEventListener('click', onWindowClick);
		return () => {
			window.removeEventListener('click', onWindowClick);
		};
	}, []);
};

function useDebounce(value, delay) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => clearTimeout(handler);
	}, [value]);

	return debouncedValue;
}

export {
	useDebounce,
	useOutsideClick,
};
